import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["id"]
const _hoisted_3 = {
  key: 0,
  class: "width-100 highlight-header-6"
}
const _hoisted_4 = { class: "d-flex align-items-center justify-content-center highlight-header-6 logo-header" }
const _hoisted_5 = {
  class: "img-box d-flex align-items-center justify-content-center",
  style: {"pointer-events":"none"}
}
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "ghost-img-div" }, null, -1)
const _hoisted_8 = {
  class: "img-box d-flex align-items-center justify-content-center",
  style: {"pointer-events":"none"}
}
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "ghost-img-div" }, null, -1)
const _hoisted_11 = { class: "padding-05" }
const _hoisted_12 = ["title"]

import { ASSETS_BASE_URL, getResolution } from "@/core/logo";
import { ref } from "vue";
import { isStepSkipped } from "@/flow/utils/skipUtils";

interface Props {
  step: any;
  index: number | string;
  listIndex: number | string;
  log: any;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'StepBox',
  props: {
    step: { default: {} },
    index: {},
    listIndex: {},
    log: { default: {} }
  },
  emits: ["open"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const props = __props;
const stepBoxRef = ref(null);

function setHighlight(status) {
  switch (status) {
    case "TRIGGERED":
      return "emptyCase";
    case "COMPLETED":
      return "highlight-success";
    case "FAILED":
      return "highlight-failed";
    case "STARTED":
      return "highlight";
    default:
      return "";
  }
}
function open(step, index, listIndex) {
  emit("open", step, `step${listIndex}-${index}`, stepBoxRef);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card border-radius-12 square-div-120 cursor-pointer stepBoxCount activity-step-box", [
      setHighlight(props.log.status),
      { 'activity-step-skipped': _unref(isStepSkipped)(_ctx.step) },
    ]]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (open(_ctx.step, _ctx.index, _ctx.listIndex))),
    id: `step${_ctx.listIndex}-${_ctx.index}`
  }, [
    _createElementVNode("div", {
      class: "d-flex justify-content-center align-items-center primary-bg secondary-border number-box-shadow step-number-badge",
      style: _normalizeStyle({ fontSize: _ctx.step.ix + 1 > 99 ? '12px' : '14px' })
    }, [
      _createElementVNode("span", null, _toDisplayString(_ctx.step.ix + 1), 1)
    ], 4),
    _createElementVNode("div", {
      class: "card-body d-flex flex-column border-radius-12 p-0 justify-content-between align-items-center",
      id: `step-unique-${_ctx.step.uniqueId}`
    }, [
      (props.log.status === 'STARTED')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("img", {
                  class: "logo-step-header",
                  src: `${_unref(ASSETS_BASE_URL)}/${_ctx.step.connectorSpecId}${_unref(getResolution)(
                true
              )}.png`,
                  alt: "logo"
                }, null, 8, _hoisted_6)
              ]),
              _hoisted_7
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(["d-flex align-items-center justify-content-center logo-header", { 'highlight-header-6': props.log.status !== 'TRIGGERED' }])
          }, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("img", {
                class: "logo-step-header",
                src: `${_unref(ASSETS_BASE_URL)}/${_ctx.step.connectorSpecId}${_unref(getResolution)(
              true
            )}.png`,
                alt: "logo"
              }, null, 8, _hoisted_9)
            ]),
            _hoisted_10
          ], 2)),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("h6", {
          class: "step-text font-size-12 truncate-text",
          title: _ctx.step.name
        }, _toDisplayString(_ctx.step.name), 9, _hoisted_12)
      ])
    ], 8, _hoisted_2)
  ], 10, _hoisted_1))
}
}

})